import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Cart, GetDeliveryMomentsResponse, OrderTypes } from '@next/core-lib/cart';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartApiService {
  protected baseUrl = this.env.APIM_BASE_URL + '/cart-v2-service';

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) protected env: AgrEnvironment,
  ) {}

  getCartLineDeliveryMoments(cartId: number, cartLineId: string, flexibility?: number): Observable<GetDeliveryMomentsResponse> {
    let params = new HttpParams();

    if (flexibility !== undefined) {
      params = params.set('flexibility', flexibility);
    }

    return this.http.get<GetDeliveryMomentsResponse>(`${this.baseUrl}/carts/${cartId}/lines/${cartLineId}/deliverydates`, { params });
  }

  getCartDeliveryMoments(cartId: number, orderType?: OrderTypes, flexibility?: number): Observable<GetDeliveryMomentsResponse> {
    let params = new HttpParams().set('ordertype', orderType ?? OrderTypes.salesOrder);

    if (flexibility !== undefined) {
      params = params.set('flexibility', flexibility);
    }

    return this.http.get<GetDeliveryMomentsResponse>(`${this.baseUrl}/carts/${cartId}/deliverydates`, {
      params,
    });
  }

  patchCartDeliveryDateAndFlexibility(cartId: number, deliveryDate: string, flexibility: number): Observable<Cart> {
    const body = {
      deliveryDate,
      flexibility,
    };

    return this.http.patch<Cart>(`${this.baseUrl}/carts/${cartId}/deliverydates`, body);
  }
}
